<template>
  <div>
    <div v-if="user.photo_url" class="rounded-circle bg-secondary" :style="photoWrapperStyles">
      <img :src="user.photo_url" :width="`${size}px`">
    </div>
    <avatar v-else :color="color" :size="size" :username="user.name" :initials="user.initials"></avatar>
  </div>
</template>

<script>
  import Avatar from 'vue-avatar'

  export default {
    components: {
      'avatar': Avatar
    },

    props: {
      user: {
        type: Object,
        required: true
      },
      color: {
        type: String,
        default: '#fff'
      },
      size: {
        type: Number,
        default: 60
      }
    },

    computed: {
      photoWrapperStyles() {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
          overflow: 'hidden'
        }
      }
    }
  }
</script>
